import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PostsPage from "../../pages/module-pages/blog/PostsPages";
import CategoriesPage from "../../pages/module-pages/blog/CategoriesPage";
import NewPostPage from "../../pages/module-pages/blog/NewPostPage";
import UpdatePostPage from "../../pages/module-pages/blog/UpdatePostPage";

export default function BlogNav() {
  return (
    <Routes>
      <Route path="/" element={<PostsPage />} />
      <Route path="/posts" element={<Navigate to="/blog" replace />} />
      <Route path="/new" element={<NewPostPage />} />
      <Route path="/update" element={<UpdatePostPage />} />
      <Route path="/categories" element={<CategoriesPage />} />
      <Route path="*" element={<Navigate to="/blog" replace />} />
    </Routes>
  );
}
